import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import IPage from 'models/Page';
import { PageEditFormProps } from '../pageEditRegistry';
import AdditionalQuestionsForm from 'pages/OwnerPage/QuizFormPage/TabContentPages/AdditionalQuestions/AdditionalQuestionsForm';

const AdditionalQuestionsPageForm: FC<PageEditFormProps> = ({ pageRef }) => {
  const { watch } = useFormContext();
  const pages: IPage[] = watch('pages') || [];
  const page = pages.find((p: IPage) => p.uuid === pageRef);

  if (!page) return null;

  return <AdditionalQuestionsForm page={page} />;
};

export default AdditionalQuestionsPageForm;
